module.exports = __webpack_public_path__ + "img/machine-30.a82c4206.svg";